<template>
  <div class="admin-role">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>角色管理</span>
          <el-button type="primary" @click="handleAdd">添加角色</el-button>
        </div>
      </template>
      <el-table :data="roleList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑角色对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="600px">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="80px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="权限">
          <el-tree
            ref="permissionTree"
            :data="permissionTree"
            show-checkbox
            node-key="id"
            :default-expand-all="true"
            :check-strictly="false"
            :default-checked-keys="form.permission_ids"
            :props="{ label: 'name', children: 'children' }"
            @check-change="handlePermissionChange"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminRole',
  data() {
    return {
      roleList: [],
      permissionTree: [],
      dialogVisible: false,
      dialogTitle: '添加角色',
      form: {},
      formRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchRoleList()
    this.fetchPermissionTree()
  },
  methods: {
    // 获取角色列表
    fetchRoleList() {
      const token = localStorage.getItem('adminToken')
      fetch('/api/admin/role/list', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('网络响应错误')
        }
        return response.json()
      })
      .then(data => {
        if (data && data.code === 0) {
          this.roleList = data.data
        } else {
          console.error('获取角色列表失败:', data.message)
          this.$message.error('获取角色列表失败')
        }
      })
      .catch(error => {
        console.error('获取角色列表失败:', error)
        this.$message.error('获取角色列表失败')
      })
    },

    // 获取权限树
    fetchPermissionTree() {
      const token = localStorage.getItem('adminToken')
      fetch('/api/admin/permission/list', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('网络响应错误')
        }
        return response.json()
      })
      .then(data => {
        if (data && data.code === 0) {
          this.permissionTree = data.data
        } else {
          console.error('获取权限列表失败:', data.message)
          this.$message.error('获取权限列表失败')
        }
      })
      .catch(error => {
        console.error('获取权限列表失败:', error)
        this.$message.error('获取权限列表失败')
      })
    },

    // 添加角色
    handleAdd() {
      console.log('点击了添加角色按钮')
      this.dialogTitle = '添加角色'
      this.form = {
        name: '',
        description: '',
        permission_ids: []
      }
      console.log('设置 dialogVisible 为 true')
      this.dialogVisible = true
      console.log('dialogVisible 的值:', this.dialogVisible)
      // 清空权限树的选中状态
      this.$nextTick(() => {
        if (this.$refs.permissionTree) {
          this.$refs.permissionTree.setCheckedKeys([])
          console.log('清空权限树选中状态')
        }
      })
    },

    // 编辑角色
    handleEdit(row) {
      console.log('点击了编辑角色按钮，row:', row)
      this.dialogTitle = '编辑角色'
      this.form = { ...row }
      // 获取角色权限
      const token = localStorage.getItem('adminToken')
      console.log('发送请求获取角色详情:', `/api/admin/role/detail?id=${row.id}`)
      fetch(`/api/admin/role/detail?id=${row.id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(response => {
        console.log('获取角色详情响应:', response)
        return response.json()
      })
      .then(data => {
        console.log('获取角色详情数据:', data)
        if (data.code === 0) {
          this.form.permission_ids = data.data.permissions.map(permission => permission.id)
          console.log('设置 permission_ids:', this.form.permission_ids)
          // 显示弹窗
          console.log('设置 dialogVisible 为 true')
          this.dialogVisible = true
          console.log('dialogVisible 的值:', this.dialogVisible)
          // 延迟更新树组件的选中状态
          this.$nextTick(() => {
            if (this.$refs.permissionTree) {
              this.$refs.permissionTree.setCheckedKeys(this.form.permission_ids)
              console.log('更新树组件选中状态:', this.form.permission_ids)
            }
          })
        }
      })
      .catch(error => {
        console.error('获取角色详情失败:', error)
        // 即使获取权限失败，也显示弹窗
        this.dialogVisible = true
      })
    },

    // 提交表单
    handleSubmit() {
      try {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            const token = localStorage.getItem('adminToken')
            const url = this.form.id ? '/api/admin/role/update' : '/api/admin/role/create'
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(this.form)
            })
            .then(response => response.json())
            .then(data => {
              if (data.code === 0) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.fetchRoleList()
              } else {
                this.$message.error(data.message)
              }
            })
          }
        })
      } catch (error) {
        this.$message.error('操作失败')
      }
    },

    // 删除角色
    handleDelete(id) {
      this.$confirm('确定要删除该角色吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/role/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchRoleList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    },
    
    // 处理权限变化
    handlePermissionChange() {
      if (this.$refs.permissionTree) {
        this.form.permission_ids = this.$refs.permissionTree.getCheckedKeys()
      }
    }
  }
}
</script>

<style scoped>
.admin-role {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
